import { Helmet } from 'react-helmet-async';

const PageSEO = ({ 
  title, 
  description, 
  keywords,
  canonical,
  ogImage = 'https://avk-pro.ru/logo.png',
  noindex = false
}) => {
  const baseUrl = 'https://avk-pro.ru';
  const fullTitle = title.includes('A.V.K. SPORT') ? title : `${title} | A.V.K. SPORT`;
  const canonicalUrl = canonical?.startsWith('http') ? canonical : `${baseUrl}${canonical || ''}`;

  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{fullTitle}</title>
      <meta name="title" content={fullTitle} />
      <meta name="description" content={description} />
      {keywords && <meta name="keywords" content={keywords} />}
      <link rel="canonical" href={canonicalUrl} />
      
      {noindex && <meta name="robots" content="noindex, nofollow" />}

      {/* Open Graph / Facebook */}
      <meta property="og:type" content="website" />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:site_name" content="A.V.K. SPORT" />

      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content={canonicalUrl} />
      <meta property="twitter:title" content={fullTitle} />
      <meta property="twitter:description" content={description} />
      <meta property="twitter:image" content={ogImage} />
    </Helmet>
  );
};

export default PageSEO;
